import { createSelector } from 'reselect';
import { getGameStaticData } from './getGameStaticData';

const getGumboGameData = (state) => state?.gumbo?.gameData || {};
const getGumboGameStatus = (state) => getGumboGameData(state)?.status || {};

const getAbstractGameState = (state) => getGumboGameStatus(state)?.abstractGameState || '';
const getDetailedGameState = (state) => getGumboGameStatus(state)?.detailedState || '';

const getLinescore = (state) => state?.gumbo?.liveData?.linescore || {};
const getInningState = (state) => getLinescore(state)?.inningState;
const getCurrentInning = (state) => getLinescore(state)?.currentInning;
const getView = (state) => state?.views?.game_view || getAbstractGameState(state)?.toLowerCase();
const getTab = (state) => state?.views?.game_tab;
const getAdRefreshRate = (state) => state?.config?.adRefreshRate;

const getAdsConf = (state) => {
    const {
        config: {
            ads = {}
        } = {}
    } = state;
    return ads;
};

export const getAdsConfig = createSelector(
    [getAdsConf, getAdRefreshRate],
    (adsConfig, adRefreshRate) => ({
        adsConfig: {
            ...adsConfig,
            adRefreshRate: adRefreshRate ?? adsConfig?.adRefreshRate ?? 60
        }
    })
);

export const getGameView = createSelector(
    [getView],
    (gameView) => ({
        gameView
    })
);

export const getGameTab = createSelector(
    [getTab],
    (gameTab) => ({
        gameTab
    })
);

export const getAdsGameState = createSelector(
    [getGameStaticData, getAbstractGameState, getDetailedGameState, getCurrentInning, getInningState],
    (gameStaticData, gameState, gameStatus, currentInning, inningState) => {
        return ({
            ...gameStaticData,
            gameState,
            gameStatus,
            currentInning,
            inningState
        });
    }
);
